import React from 'react';
import SkillIcon from './SkillIcon';

const backendData = [
   { id: 1, name: 'App Security' },
   { id: 2, name: 'C++ (NDK)' },
   { id: 3, name: 'PHP' },
   { id: 4, name: 'Python' },
   { id: 5, name: 'MySQL' },
];

const BackendSkill = () => (
   <>
      {backendData.map(({ id, name }) => (
         <div key={id} className="skill-card group">
            <SkillIcon name={name} className="skill-icon" />
            <p className="skill-name">{name}</p>
         </div>
      ))}
   </>
);

export default BackendSkill;

